(function () {
  function normalizeLocale(locale) {
    var rawLocale = String(
      locale ||
      (window.Shopify && window.Shopify.locale) ||
      (document.documentElement && document.documentElement.lang) ||
      'en'
    ).trim();
    var lowerLocale = rawLocale.toLowerCase();

    if (lowerLocale === 'zh-cn') return 'zh-CN';
    if (lowerLocale === 'zh-tw') return 'zh-TW';
    if (lowerLocale.indexOf('zh') === 0) return lowerLocale.indexOf('tw') !== -1 ? 'zh-TW' : 'zh-CN';
    if (lowerLocale.indexOf('de') === 0) return 'de';
    if (lowerLocale.indexOf('fr') === 0) return 'fr';
    if (lowerLocale.indexOf('it') === 0) return 'it';
    if (lowerLocale.indexOf('nl') === 0) return 'nl';
    if (lowerLocale.indexOf('es') === 0) return 'es';
    if (lowerLocale.indexOf('ja') === 0) return 'ja';
    if (lowerLocale.indexOf('ko') === 0) return 'ko';
    if (lowerLocale.indexOf('th') === 0) return 'th';
    return 'en';
  }

  function getSpecialCountryName(countryCode, locale) {
    var normalizedLocale = normalizeLocale(locale);
    var specialNames = {
      HK: {
        en: 'Hong Kong (China)',
        'zh-CN': '中国香港',
        'zh-TW': '中國香港'
      },
      TW: {
        en: 'Taiwan (China)',
        'zh-CN': '中国台湾',
        'zh-TW': '中國台灣'
      },
      MO: {
        en: 'Macao (China)',
        'zh-CN': '中国澳门',
        'zh-TW': '中國澳門'
      }
    };

    var names = specialNames[String(countryCode || '').toUpperCase()];
    if (!names) return '';
    return names[normalizedLocale] || names.en || '';
  }

  function getLocalizedCountryName(countryCode, locale, fallbackName) {
    var normalizedCode = String(countryCode || '').toUpperCase();
    if (!normalizedCode) return fallbackName || '';

    var specialName = getSpecialCountryName(normalizedCode, locale);
    if (specialName) return specialName;

    if (typeof Intl !== 'undefined' && Intl.DisplayNames) {
      try {
        var displayNames = new Intl.DisplayNames([normalizeLocale(locale), 'en'], { type: 'region' });
        var localizedName = displayNames.of(normalizedCode);
        if (localizedName && localizedName !== normalizedCode) {
          return localizedName;
        }
      } catch (error) {}
    }

    return fallbackName || normalizedCode;
  }

  function getLocalizedCountryNameFromEnglishName(countryName, nameToCodeMap, locale) {
    var code = String((nameToCodeMap && nameToCodeMap[countryName]) || '').toUpperCase();
    return getLocalizedCountryName(code, locale, countryName);
  }

  window.CountryDisplayUtils = {
    normalizeLocale: normalizeLocale,
    getLocalizedCountryName: getLocalizedCountryName,
    getLocalizedCountryNameFromEnglishName: getLocalizedCountryNameFromEnglishName
  };
})();
